<div class="content-wrapper-parent">
  <div class="content-wrapper">
    <div class="activity-content">
      <div class="page-header">
        <h1>Data Sources</h1>
        <div class="header-actions-right">
          <mat-form-field class="search-box" appearance="outline">
            <mat-icon matPrefix svgIcon="search"></mat-icon>
            <input matInput placeholder="Search data sources..." [(ngModel)]="searchQuery" (ngModelChange)="applyFilter($event)">
            <button *ngIf="searchQuery" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>

          <button mat-raised-button color="primary" class="add-btn" (click)="openNewDataSourceDialog()">
            New Data Source
          </button>
        </div>
      </div>
      
      <!-- Loading State -->
      <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Loading data sources...</p>
      </div>
      
      <!-- Data Sources Table -->
      <div *ngIf="!loading" class="table-wrapper">
        <div class="activity-table-container table-container">
          <table mat-table [dataSource]="dataSource" matSort #sortTable="matSort" class="activity-table">
            
            <!-- Icon Column -->
            <ng-container matColumnDef="icon">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let dataSource" class="icon-cell">
                <mat-icon [svgIcon]="getDataSourceIcon(dataSource)" class="activity-icon"></mat-icon>
              </td>
            </ng-container>

            <!-- Data Source Name Column -->
            <ng-container matColumnDef="dataSourceName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let dataSource" class="activity-name">{{ dataSource.dataSourceName }}</td>
            </ng-container>

            <!-- Type Column -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
              <td mat-cell *matCellDef="let dataSource">{{ getDataSourceTypeLabel(dataSource.dataSourceTypeId) }}</td>
            </ng-container>

            <!-- Tags Column -->
            <ng-container matColumnDef="tags">
              <th mat-header-cell *matHeaderCellDef>Tags</th>
              <td mat-cell *matCellDef="let dataSource" class="tags-cell">
                <ng-container *ngIf="formatTags(dataSource.tags).length > 0; else noTags">
                  <ng-container *ngFor="let tag of formatTags(dataSource.tags)">
                    <span class="tag-text">{{ tag }}</span>
                  </ng-container>
                </ng-container>
                <ng-template #noTags>
                  <span class="no-tags">No tags</span>
                </ng-template>
              </td>
            </ng-container>

            <!-- Project Count Column -->
            <ng-container matColumnDef="projectCount">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Workflows</th>
              <td mat-cell *matCellDef="let dataSource">
                <button class="project-count-link" (click)="onProjectCountClick($event, dataSource)"
                  [matTooltip]="dataSource.projectCount ? 'View ' + dataSource.projectCount + ' cleaning workflow(s)' : 'No workflows'"
                  [disabled]="!dataSource.projectCount">
                  <span>{{ dataSource.projectCount || 0 }}</span>
                  <mat-icon *ngIf="dataSource.projectCount" svgIcon="arrow_forward"></mat-icon>
                </button>
              </td>
            </ng-container>

            <!-- Created Column -->
            <ng-container matColumnDef="createdAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Created At</th>
              <td mat-cell *matCellDef="let dataSource">{{ formatDate(dataSource.createdAt) }}</td>
            </ng-container>

            <!-- Updated Column -->
            <ng-container matColumnDef="updatedAt">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated</th>
              <td mat-cell *matCellDef="let dataSource">{{ formatDate(dataSource.updatedAt) }}</td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let dataSource" class="actions-cell">
                <button mat-icon-button class="action-btn" (click)="onEditDataSource(dataSource)" matTooltip="Edit data source" aria-label="Edit data source">
                  <mat-icon svgIcon="pencil-blue"></mat-icon>
                </button>
                <button mat-icon-button class="action-btn" (click)="onDeleteDataSource(dataSource)" matTooltip="Delete data source" aria-label="Delete data source">
                  <mat-icon svgIcon="delete"></mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="activity-row"></tr>
            
          </table>
        </div>
      </div>
    </div>
  </div>
</div>